// extracted by mini-css-extract-plugin
export default {"card":"socialCard_card__MTHSJ","icon":"socialCard_icon__VP4Oe","copy":"socialCard_copy__qZ59m"};